/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { Grid, Tooltip } from "@mui/material";
import "./helper.scss";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../../localization/keys";

export const OrganisationCell = (cellValues: any) => {
  const [t] = useTranslation();

  if (cellValues?.row?.organization?.length == 0) {
    return <>{t(localeKeyMap.noOrganization)}</>;
  } else if (cellValues?.row?.organization?.length > 0) {
    const remainingOptions = cellValues?.row?.organization.slice(1);
    const remainingLabels = remainingOptions.map((option: any) => option.name);
    const commaSeparatedString = remainingLabels.join(", ");
    // return cellValues.row.organizationId[0] + "..." + <div>test</div>;
    return (
      <Grid>
        <Tooltip
          placement="right-start"
          arrow
          title={cellValues?.row?.organization
            .slice(1) // Skip the first element

            .map((el: any) => el.name)
            .join(", ")}
        >
          {cellValues?.row?.organization?.length == 1 ? (
            cellValues?.row?.organization[0]?.name
          ) : (
            <div>
              {cellValues?.row?.organization[0]?.name}, &nbsp;
              <span style={{ color: "#0071B3" }}>
                +{cellValues?.row?.organization?.length - 1}
              </span>
            </div>
          )}
        </Tooltip>
      </Grid>
    );
  } else {
    return <></>;
  }
};

export default OrganisationCell;
